module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_plan_show_bg_03-9761995c28adbe1619780cae86b92962.jpg";